// Function to wait for the Reamaze widget to be dynamically inserted into the DOM
function waitForReamazeWidget() {
  const checkInterval = setInterval(() => {
    const reamazeWidget = document.querySelector("#reamaze-widget");
    const reamazeWidgetLabelContainer = document.querySelector("#reamaze-widget-label-container");

    if (reamazeWidget) {
      clearInterval(checkInterval); // Stop checking once the widget is found
      initializeObservation(reamazeWidget, reamazeWidgetLabelContainer); // Start observing changes once the widget is available
    }
  }, 500); // Check every 500ms for the widget
}

// Function to initialize observation on the mobile drawer, side panel, product drawer, and handle widget visibility
function initializeObservation(reamazeWidget, reamazeWidgetLabelContainer) {
  // Function to toggle the Reamaze widget and label container based on the element's state (mobile drawer, side panel, or product drawer)
  function toggleReamazeWidget(element) {
    if (element.hasAttribute("open") || element.classList.contains("active")) {
      // Hide the widget and label container by fading out
      if (reamazeWidget) {
        reamazeWidget.style.opacity = "0";
        // Optional: After fade-out, set display to none to prevent interaction. Use a timeout matching the transition duration.
        setTimeout(() => reamazeWidget.style.display = "none", 500); // Match the transition duration
      }
      if (reamazeWidgetLabelContainer) {
        reamazeWidgetLabelContainer.style.opacity = "0";
        setTimeout(() => reamazeWidgetLabelContainer.style.display = "none", 500); // Match the transition duration
      }
    } else {
      // Ensure the widget and label container are considered displayed before starting the fade-in effect
      if (reamazeWidget) {
        reamazeWidget.style.display = "block";
        // Use a slight delay before changing opacity to ensure the display property applies correctly
        setTimeout(() => reamazeWidget.style.opacity = "1", 300); // Start fading in after a short delay
      }
      if (reamazeWidgetLabelContainer) {
        reamazeWidgetLabelContainer.style.display = "block";
        setTimeout(() => reamazeWidgetLabelContainer.style.opacity = "1", 300); // Start fading in after a short delay
      }
    }
  }

  // Get the mobile drawer element
  const mobileDrawer = document.querySelector("details.mobile-toggle-wrapper");
  // Get the side panel elements
  const sidePanels = document.querySelectorAll(".side-panel");
  // Get the product drawer element
  const productDrawer = document.querySelector(".side-panel.product-drawer");

  // Initial check in case the drawer's, side panel's, or product drawer's state is already set before the observer is initialized
  if (mobileDrawer) toggleReamazeWidget(mobileDrawer);
  sidePanels.forEach((sidePanel) => toggleReamazeWidget(sidePanel));
  if (productDrawer) toggleReamazeWidget(productDrawer);

  // Add a mutation observer to watch for changes in the open attribute of the mobile drawer, class changes in the side panels, and product drawer
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "open" &&
        mutation.target === mobileDrawer
      ) {
        toggleReamazeWidget(mutation.target);
      }
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class" &&
        (Array.from(sidePanels).includes(mutation.target) ||
          mutation.target === productDrawer)
      ) {
        toggleReamazeWidget(mutation.target);
      }
    });
  });

  // Configure the observer to watch for attribute changes on all elements
  if (mobileDrawer) observer.observe(mobileDrawer, { attributes: true });
  sidePanels.forEach((sidePanel) =>
    observer.observe(sidePanel, { attributes: true })
  );
  if (productDrawer) observer.observe(productDrawer, { attributes: true });

  // Ensure the widget and label container have transition styles for opacity
  if (reamazeWidget) {
    reamazeWidget.style.transition = "opacity 0.5s ease-in-out";
  }
  if (reamazeWidgetLabelContainer) {
    reamazeWidgetLabelContainer.style.transition = "opacity 0.5s ease-in-out";
  }
}

// Start waiting for the Reamaze widget to be inserted
waitForReamazeWidget();